<script>
import BlankHeader from '@/components/templates/blank-header.vue'
import FooterComponent from '@/components/templates/footer.vue'

export default {
  components: {
    BlankHeader,
    FooterComponent
  }
};
</script>

<template>
  <div>
    <BlankHeader/>
    <div class="blank-page account-pages landing-page">
      <div class="container">
        <slot />
      </div>
    </div>
    <FooterComponent/>
  </div>
</template>
<style scoped>
.landing-page {
background: url('~@/assets/images/passenger_bg.jpg') no-repeat rgba(255, 255, 255, 1);
      background-position: center bottom;
    background-size: cover;
}
/* responsive */
@media screen and (max-width: 600px) {
  .blank-page > .container {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .blank-page {
    height: calc(100vh - 175px)!important;
  }
  .login-loading > .row > .col {
    padding-left:2px;
    padding-right: 2px
  }
  .login-loading{
    padding: 0 1.5rem;
  }
}
</style>